// extracted by mini-css-extract-plugin
export default {"text":"IFTextSkeleton_text__KEpsS"};